import { useEffect, useState } from 'react'
import cn from 'classnames'
import s from 'pages/common.module.scss'
import useBienAVendre from 'hooks/useBienAVendre'
import BienAVendreFilters from 'enums/BienAVendreFilters'

import { animateScroll as scroll } from 'react-scroll'

const PanelFiltres = (): JSX.Element => {
  const { toggleResultFilterAction, bienAVendreResultFilter } = useBienAVendre()
  const [activeFilter, setActiveFilter] = useState(BienAVendreFilters.Tous)

  const scrollToTop = () =>
    scroll.scrollToTop({
      containerId: 'parcelle-list-result',
      duration: 100,
      delay: 0,
    })

  const changeFilter = (filter: BienAVendreFilters) => {
    setActiveFilter(filter)
    toggleResultFilterAction(filter)
    scrollToTop()
  }

  useEffect(() => {
    if (bienAVendreResultFilter !== null) {
      changeFilter(bienAVendreResultFilter)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bienAVendreResultFilter])

  return (
    <div id="filters-bien-a-vendre">
      <p>
        <b>Filtres d&apos;affichage :</b>
      </p>
      <div className={s.filterToggle}>
        <button
          type="button"
          className={cn(
            s.buttonToggle,
            activeFilter === BienAVendreFilters.Tous ? s.active : ''
          )}
          onClick={() => changeFilter(BienAVendreFilters.Tous)}
          onKeyPress={() => changeFilter(BienAVendreFilters.Tous)}
          tabIndex={0}
        >
          Tous les résultats
        </button>
        <button
          type="button"
          className={cn(
            s.buttonToggle,
            activeFilter === BienAVendreFilters.DejaVus ? s.active : ''
          )}
          onClick={() => changeFilter(BienAVendreFilters.DejaVus)}
          onKeyPress={() => changeFilter(BienAVendreFilters.DejaVus)}
          tabIndex={0}
        >
          A consulter
        </button>
        <button
          type="button"
          className={cn(
            s.buttonToggle,
            activeFilter === BienAVendreFilters.Favoris ? s.active : ''
          )}
          onClick={() => changeFilter(BienAVendreFilters.Favoris)}
          onKeyPress={() => changeFilter(BienAVendreFilters.Favoris)}
          tabIndex={0}
        >
          En favoris
        </button>
      </div>
    </div>
  )
}

export default PanelFiltres
